import React, { useState } from "react";
import type { WorkspaceChangeRequest } from "../../api";

type Props = {
  items: WorkspaceChangeRequest[];
  disabled?: boolean;
  onAdd: (text: string) => void | Promise<void>;
  onToggle: (id: string, done: boolean) => void | Promise<void>;
  onDelete: (id: string) => void | Promise<void>;
};

export const ChangeRequestsPanel: React.FC<Props> = ({
  items,
  disabled,
  onAdd,
  onToggle,
  onDelete,
}) => {
  const [text, setText] = useState("");
  const open = items.filter((i) => !i.done).length;
  const total = items.length;

  const submit = async (): Promise<void> => {
    const t = text.trim();
    if (!t || disabled) return;
    await onAdd(t);
    setText("");
  };

  return (
    <div className="side-panel cr-panel">
      <div className="side-panel-head">
        <h4>✅ Change Requests</h4>
        <span className={`side-panel-count ${open > 0 ? "warn" : "good"}`}>
          {total - open}/{total}
        </span>
      </div>
      <div className="side-panel-add">
        <textarea
          rows={2}
          value={text}
          placeholder={disabled ? "Erst Reel speichern…" : "Neuer Change Request (Cmd+Enter)…"}
          disabled={disabled}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if ((e.metaKey || e.ctrlKey) && e.key === "Enter") void submit();
          }}
        />
        <button
          className="btn primary sm"
          onClick={() => void submit()}
          disabled={disabled || text.trim().length === 0}
        >
          Hinzufügen
        </button>
      </div>
      <ul className="side-panel-list cr-list">
        {items.length === 0 ? (
          <li className="side-panel-empty">Keine offenen Punkte.</li>
        ) : (
          items.map((cr) => (
            <li key={cr.id} className={`cr-item ${cr.done ? "done" : ""}`}>
              <label className="cr-check">
                <input
                  type="checkbox"
                  checked={cr.done}
                  onChange={(e) => void onToggle(cr.id, e.target.checked)}
                />
                <span className="cr-text">{cr.text}</span>
              </label>
              <div className="cr-meta">
                <span>{formatDate(cr.createdAt)}</span>
                <button
                  className="link-btn"
                  onClick={() => void onDelete(cr.id)}
                  title="löschen"
                >
                  ✕
                </button>
              </div>
            </li>
          ))
        )}
      </ul>
    </div>
  );
};

function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString("de-DE", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}
